import { render, staticRenderFns } from "./CoreObjectBox.vue?vue&type=template&id=2af7635c&"
import script from "./CoreObjectBox.vue?vue&type=script&lang=js&"
export * from "./CoreObjectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports